import { AXIOS_INSTANCE } from "..";
import { CASINO_SERVICE_URL } from "../../utils/constants";

export const getCasinoOddsAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${CASINO_SERVICE_URL}/odds`, {
      params: {
        casinoGames: game,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};
export const getUniversalCasinoOddsAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/uni-odds`,
      {
        params: {
          casinoGames: game,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getUniversalCasinoLastResultAPI = async (game, eventId) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/uni-last-10-results`,
      {
        params: {
          casinoGames: game,
          eventId,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getCasinoLastTenResultAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/last-10-results`,
      {
        params: {
          casinoGames: game,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getCasinoBetsAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(`${CASINO_SERVICE_URL}/my-bet`, {
      params: {
        casinoGames: game,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};
export const getBallByBallOddsAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/uni-odds?casinoGames=UNI_BALL_BY_BALL`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getCasinoExposureAPI = async (marketId) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/pl-exposure`,
      {
        params: {
          marketId: marketId,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const casinoBetAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/bet/place`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const casinoBallByBallBetAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/ball-by-ball/place`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const uniCasinoBetAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/uni-bet/place`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const casinoReportHistoryAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/casino-report-history`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getIndividualResultCasinoAPI = async (marketId, casinoGame) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/individaul-result`,
      {
        params: {
          marketId: marketId,
          casinoGame,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getUniversalCasinoTVAPI = async (game, signal) => {
  const { data } = await AXIOS_INSTANCE.get(`${CASINO_SERVICE_URL}/uni-tv`, {
    params: { casinoGames: game },
    signal,
    timeout: 15000,
  });
  return data;
};
